import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e31beb90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background-image" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background-overlay" }, null, -1))
const _hoisted_4 = { class: "text-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "primary-text" }, " N'hésitez pas à m'envoyer votre avis par mail ", -1))
const _hoisted_6 = { class: "secondary-text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "secondary-text second" }, " ou en cliquant sur le bouton ci-dessous ! ", -1))
const _hoisted_8 = { class: "contact-container extended-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, " à l'adresse " + _toDisplayString(_ctx.contactEmail), 1),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("a", {
          id: "contact-link",
          href: "#",
          title: "Contacter par mail",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.contactByEmail && _ctx.contactByEmail(...args)))
        }, "Contact")
      ])
    ])
  ]))
}